import React, { useState, useEffect, useRef } from 'react';
import '../CreateProduct.css';
import NotFound from '../../../Images/notFound.png';
import {
  Button,
  makeStyles, Paper,
  Dialog, DialogTitle, DialogContent, DialogActions,
  Select,
  MenuItem
} from '@material-ui/core';
import clsx from 'clsx';
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import CheckUserProvider from '../../../AllHooks/CheckUserProvider';
import { Helmet } from 'react-helmet';
import { getSupplyOrderDocumentWithUserId, getTodaySupplyOrderDocument, updateSupplyOrderDocument } from '../../../Backend/firebase/supply-order';
import { parseDate } from '../../Models/CommonFunc';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import CustomAlert from '../../CustomAlert';

const useStyles = makeStyles((theme) => ({
  root: {

  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'initial',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: '100%',
    padding: '20px',
  },
}));

function ChemistMedicineReturns() {
  const classes = useStyles();
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  const [openNotify, setOpenNotify] = React.useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');
  const [alertType, setAlertType] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [TodayDate, setTodayDate] = useState(parseDate(new Date()));
  const [ChemistEntry, setChemistEntry] = useState([]);
  const [supplyOrderList, setSupplyOrderList] = useState([]);
  const { userData } = CheckUserProvider();


  useEffect(async () => {
    if (userData) {
      try {
        setIsLoading(true);
        const getSupplyOrder = await getSupplyOrderDocumentWithUserId(userData.uid);
        setSupplyOrderList(getSupplyOrder);

        const filteredReturnedItems = getSupplyOrder?.filter(x => x?.Status === "returned");
        setChemistEntry(filteredReturnedItems);
        setIsLoading(false);
      } catch (error) {
        console.log("Error Occur in Get Order", error);
        setIsLoading(false);
      }
    }
  }, [userData]);

  const handleTodayDateChange = (e) => {
    setTodayDate(parseDate(e.target.value));
    setIsLoading(true);
    const filterRecord = supplyOrderList?.filter(x =>
      parseDate(x.SupplyOrderPostedDateTime).includes(parseDate(e.target.value))
    );

    const filteredReturnedItems = filterRecord?.filter(x => x?.Status === "returned");
    setChemistEntry(filteredReturnedItems);
    setIsLoading(false);
  };

  return (
    <>
      <div className="createProduct mt-2">
        {isLoading && <div className="loader-container">
          <div className="loader"></div>
        </div>}
        <Helmet>
          <meta name="description" content="Creating New Product And Sales page." />
          <title>Medicine Returns | Kaipsool Pharmatech</title>
        </Helmet>
        <Paper className={fixedHeightPaper}>
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-md-12">
              <div className="row mb-3">
                <h5 className="col-md-9 mb-2">Return/Bounce Medicine &nbsp; </h5>
                <div className="col-md-3 mb-2">
                  <span className="form-control registerEmp__textbox registerEmp__datePicker">
                    <DatePickerComponent
                      id="TodayDate"
                      name="TodayDate"
                      value={TodayDate}
                      cssclassName="e-outline"
                      onChange={(e) => handleTodayDateChange(e)}
                      format="dd/MM/yyyy"
                      cleared={() => setTodayDate('')}
                    />
                  </span>
                </div>
              </div>

              {ChemistEntry?.length > 0 ? (
                <div className="row mb-3 ml-5 table-overflow">
                  <h6>Search Result:</h6>
                  <table className="table">
                    <thead>
                      <tr>
                        <td><b>Chemist Info</b></td>
                        <td><b>Product Name</b></td>
                        <td><b>Quantity</b></td>
                        <td><b>Scheme</b></td>
                        <td><b>Wholesaler Info</b></td>
                        <td><b>Feedback</b></td>
                        <td><b>Date</b></td>
                      </tr>
                    </thead>
                    <tbody>
                      {ChemistEntry.map((chemist, index) => {
                        return (
                          <tr key={chemist._id}>
                            <td>{chemist?.ChemistInfo}</td>
                            <td>{chemist?.ProductName}</td>
                            <td>{chemist?.ProductQuantity || "NA"}</td>
                            <td>{chemist?.ProductScheme || "NA"}</td>
                            <td>{chemist?.WholesalerId || "NA"}</td>
                            <td><b>{`${chemist?.Status || ""} - ${chemist?.Feedback || ""}` || "NA"}</b></td>
                            <td>{typeof chemist?.SupplyOrderPostedDateTime === "string"
                              ? chemist?.SupplyOrderPostedDateTime
                              : parseDate(chemist?.SupplyOrderPostedDateTime).toLocaleString()}</td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              ) : <div className="row col-md-12 mt-3 text-center">
                <img src={NotFound} className="notFound" />
                <h4>No Goods Found for Return!</h4>
              </div>}
            </div>
          </div>
        </Paper>
      </div>
      <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType}
        notificationMessage={notificationMessage} verticalPosition="top" horizontalPosition="right" />
    </>
  );
}

export default ChemistMedicineReturns;

